var config = {}
if (process.env.NODE_ENV === 'development') {
  config = {
    appId: 'wxa5eeeeab1982d56d',
    baseUrl: 'http://jf.qumahudong.com',
    // apiBaseUrl: 'http://127.0.0.1:8002'
    apiBaseUrl: 'https://jf-admin.qumahudong.com'
    // apiBaseUrl: 'http://jf-admin.qumahudong.com'
  }
} else if (process.env.NODE_ENV === 'production') {
  config = {
    appId: 'wxa5eeeeab1982d56d',
    baseUrl: 'http://jf.qumahudong.com',
    apiBaseUrl: 'https://jf-admin.qumahudong.com'
  }
}
export default config



// WEBPACK FOOTER //
// ./src/config/config.js